interface IconProps {
  color?: string;
  className?: string;
}

export default function LastReportIcon({
  color = "#8E929E",
  className = "",
}: IconProps) {
  return (
    <svg
      width="15"
      height="15"
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g clipPath="url(#clip0_6668_66464)">
        <path
          d="M10 14.5861C10.4663 14.5861 10.8443 14.2155 10.8443 13.7584C10.8443 13.3012 10.4663 12.9307 10 12.9307C9.53373 12.9307 9.15573 13.3012 9.15573 13.7584C9.15573 14.2155 9.53373 14.5861 10 14.5861Z"
          fill={color}
        />
        <path
          d="M12.1764 13.179C12.6427 13.179 13.0206 12.8084 13.0206 12.3513C13.0206 11.8941 12.6427 11.5236 12.1764 11.5236C11.7101 11.5236 11.3321 11.8941 11.3321 12.3513C11.3321 12.8084 11.7101 13.179 12.1764 13.179Z"
          fill={color}
        />
        <path
          d="M13.6679 10.9994C14.1342 10.9994 14.5122 10.6288 14.5122 10.1717C14.5122 9.71457 14.1342 9.34399 13.6679 9.34399C13.2016 9.34399 12.8236 9.71457 12.8236 10.1717C12.8236 10.6288 13.2016 10.9994 13.6679 10.9994Z"
          fill={color}
        />
        <path
          d="M14.1557 8.49783C14.622 8.49783 15 8.12725 15 7.67012C15 7.21299 14.622 6.84241 14.1557 6.84241C13.6894 6.84241 13.3114 7.21299 13.3114 7.67012C13.3114 8.12725 13.6894 8.49783 14.1557 8.49783Z"
          fill={color}
        />
        <path
          d="M8.31145 7.16432V3.39363C8.31145 2.93379 7.93622 2.56592 7.46717 2.56592C6.99813 2.56592 6.62289 2.93379 6.62289 3.39363V7.50461C6.62289 7.72533 6.7167 7.93686 6.8668 8.0932L9.1182 10.2912C9.28706 10.4568 9.50282 10.5304 9.71858 10.5304C9.93434 10.5304 10.1501 10.4476 10.319 10.2912C10.6473 9.96935 10.6473 9.44513 10.319 9.12324L8.32083 7.16432H8.31145Z"
          fill={color}
        />
        <path
          d="M14.3902 3.51319L13.6398 0.625387C13.5272 0.18394 13.0582 -0.0919639 12.6173 0.0275946C12.167 0.137956 11.8949 0.5886 12.0075 1.03005L12.2795 2.06929C10.9381 0.965669 9.24953 0.340286 7.47655 0.340286C3.34897 0.349483 0 3.63274 0 7.67015C0 11.7075 3.34897 14.9908 7.46717 14.9908C7.93621 14.9908 8.31144 14.6229 8.31144 14.1631C8.31144 13.7033 7.93621 13.3354 7.46717 13.3354C4.27767 13.3354 1.68856 10.7971 1.68856 7.67015C1.68856 4.54323 4.28705 2.00491 7.46717 2.00491C8.88368 2.00491 10.2439 2.51993 11.2946 3.43041L10.4128 3.65114C9.96248 3.7615 9.69043 4.21214 9.803 4.65359C9.89681 5.03066 10.2439 5.27897 10.6191 5.27897C10.6848 5.27897 10.7598 5.27897 10.8255 5.25138L13.7711 4.51564C14.2214 4.40528 14.4934 3.95463 14.3809 3.51319H14.3902Z"
          fill={color}
        />
      </g>
      <defs>
        <clipPath id="clip0_6668_66464">
          <rect width="15" height="15" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
